// src/components/QuotesList.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import './QuotesList.css';

const QuotesList = () => {
    const { currentUser } = useAuth();
    const [quotes, setQuotes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedQuoteId, setExpandedQuoteId] = useState(null); // <-- NOVO: Controla qual cotação está expandida

    useEffect(() => {
        const fetchQuotes = async () => {
            if (!currentUser) return;
            setIsLoading(true);
            try {
                const q = query(
                    collection(db, 'users', currentUser.uid, 'cotacoes'),
                    orderBy('createdAt', 'desc')
                );
                const querySnapshot = await getDocs(q);
                const quotesData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setQuotes(quotesData);
            } catch (err) {
                console.error("Erro ao buscar cotações:", err);
                setError("Não foi possível carregar suas cotações.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchQuotes();
    }, [currentUser]);
    
    // NOVO: Função para alternar a exibição dos detalhes
    const handleToggleDetails = (quoteId) => {
        setExpandedQuoteId(prevId => (prevId === quoteId ? null : quoteId));
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return 'Data indisponível';
        return new Date(timestamp.seconds * 1000).toLocaleDateString('pt-BR');
    };
    
    const formatPrice = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

    if (isLoading) {
        return <p>Carregando suas cotações...</p>;
    }

    if (error) {
        return <p style={{ color: 'red' }}>{error}</p>;
    }

    return (
        <div className="quotes-list-container">
            <h3>Minhas Cotações</h3>
            <p>Acompanhe o histórico de suas solicitações. Clique em uma linha para ver os detalhes.</p>
            {quotes.length === 0 ? (
                <p>Você ainda não fez nenhuma solicitação de cotação.</p>
            ) : (
                <div className="quotes-table-wrapper">
                    <table className="quotes-table">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Status</th>
                                <th>Nº de Itens</th>
                                <th>ID da Solicitação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {quotes.map(quote => (
                                <React.Fragment key={quote.id}>
                                    <tr className="quote-summary-row" onClick={() => handleToggleDetails(quote.id)}>
                                        <td>{formatDate(quote.createdAt)}</td>
                                        <td><span className={`status status-${quote.status}`}>{quote.status || 'nova'}</span></td>
                                        <td>{quote.items ? quote.items.length : 0}</td>
                                        <td>{quote.id}</td>
                                    </tr>
                                    {/* NOVO: Linha de detalhes que só aparece quando expandida */}
                                    {expandedQuoteId === quote.id && (
                                        <tr className="quote-details-row">
                                            <td colSpan="4">
                                                <div className="quote-details-content">
                                                    <h4>Itens Solicitados</h4>
                                                    <table className="details-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Produto</th>
                                                                <th>SKU</th>
                                                                <th>Qtd.</th>
                                                                <th>Preço Sugerido</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {quote.items.map(item => (
                                                                <tr key={item.id}>
                                                                    <td>{item.nome}</td>
                                                                    <td>{item.sku}</td>
                                                                    <td>{item.quantity}</td>
                                                                    <td>{formatPrice(item.precoSugerido)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <h4>Sua Mensagem</h4>
                                                    <p className="project-details">
                                                        {quote.customerInfo?.projectDetails || 'Nenhuma mensagem adicional enviada.'}
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default QuotesList;